export default __webpack_public_path__ + "static/media/commuter-benefit-account-guide.0a1fa56b.svg";